import { render, staticRenderFns } from "./view_branding.vue?vue&type=template&id=21b9ba3f&scoped=true"
import script from "./view_branding.vue?vue&type=script&lang=js"
export * from "./view_branding.vue?vue&type=script&lang=js"
import style0 from "./view_branding.vue?vue&type=style&index=0&id=21b9ba3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9ba3f",
  null
  
)

export default component.exports